'use strict';

require('../../../../../aviary-core/dist/cjs/index.cjs');

var BADGE_SIZES = /*#__PURE__*/ function(BADGE_SIZES) {
    BADGE_SIZES["xsmall"] = "xsmall";
    BADGE_SIZES["small"] = "small";
    BADGE_SIZES["medium"] = "medium";
    return BADGE_SIZES;
}({});

exports.BADGE_SIZES = BADGE_SIZES;
//# sourceMappingURL=InternalBadge.web.types.cjs.map
